import "./RequestYourApplicationOnline.module.css";
import Header from "@/reusable_sections/Header";
import RequestForm from "./sections/RequestForm";
import Footer from "@/reusable_sections/Footer";
export default function RequestYourApplicationOnlinePage() {
  return <div>
      <Header />
      <RequestForm />
      <Footer />
    </div>;
}